import { select } from "redux-saga/effects";

import { history } from "state/history";
import { getPaymentByID } from "state/school_money/selectors";

export default function* goToPaymentSaga(action) {
  
  const { paymentID } = action.payload;
  
  const payment = yield select(getPaymentByID, paymentID);
  const studentID = payment.get("studentID");
  
  history.push(`/school_money/payments/${studentID}/`);
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/goToPaymentSaga.js